<app-auth-layout>
  <h1 class="text-xl font-bold text-gray-900 text-center dark:text-white mb-6">Sign in to your account</h1>
  <form (ngSubmit)="onLogin(loginForm)" class="space-y-6" #loginForm="ngForm">
    <div>
      <label for="email" class="sr-only">Email Address</label>
      <input
        id="email"
        name="email"
        type="email"
        [(ngModel)]="email"
        autocomplete="email"
        required
        #emailField="ngModel"
        data-cy="page-login-input-email"
        class="appearance-none relative block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 placeholder-gray-500 dark:placeholder-gray-400 text-gray-900 dark:text-white rounded-md focus:outline-none focus:ring-sky-500 focus:border-sky-500 focus:z-10 sm:text-sm"
        placeholder="Email Address"
        (focus)="onFieldFocus()"
      />
      <app-form-field-error [errors]="getErrors(emailField)"></app-form-field-error>
    </div>
    <div>
      <label for="password" class="sr-only">Password</label>
      <div class="relative">
        <input
          id="password"
          name="password"
          [type]="passwordVisible ? 'text' : 'password'"
          [(ngModel)]="password"
          autocomplete="current-password"
          required
          #passwordField="ngModel"
          data-cy="page-login-input-password"
          class="appearance-none relative block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 placeholder-gray-500 dark:placeholder-gray-400 text-gray-900 dark:text-white rounded-md focus:outline-none focus:ring-sky-500 focus:border-sky-500 focus:z-10 sm:text-sm pr-10"
          placeholder="Password"
          (focus)="onFieldFocus()"
        />
        <button
          type="button"
          data-cy="page-login-button-togglePassword"
          (click)="togglePasswordVisibility()"
          class="absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5 text-gray-500 dark:text-gray-400 focus:outline-none hover:cursor-pointer"
          aria-label="Toggle password visibility"
        >
          @if (passwordVisible) {
          <span class="material-symbols-outlined">visibility_off</span>
          } @else {
          <span class="material-symbols-outlined">visibility</span>
          }
        </button>
      </div>
      <app-form-field-error [errors]="getErrors(passwordField)"></app-form-field-error>
    </div>

    @if (isError) {
    <div
      data-cy="page-login-text-error"
      class="p-3 rounded-md text-center font-medium border text-red-500 dark:text-red-400 bg-red-50 dark:bg-red-900 border-red-200 dark:border-red-700"
    >
      Invalid credentials
    </div>
    }

    <div>
      <button
        type="submit"
        [disabled]="isLoading"
        data-cy="page-login-button-signIn"
        class="btn-primary group relative w-full flex justify-center"
      >
        <span>
          Sign in @if (isLoading) {
          <span class="animate-ping">...</span>
          }
        </span>
      </button>
    </div>
    <div class="text-center text-sm">
      <a routerLink="/forgot-password" data-cy="page-login-link-forgotPassword" class="link"> Forgot your password? </a>
    </div>
  </form>
</app-auth-layout>
